var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"EchartsMapPie"}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"mainPie3D"}})])
}]

export { render, staticRenderFns }